import { HistoryLayout } from '@features/ForestOwner/Search/Overview/History/HistoryLayout.tsx'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/forestowner/$forestownerId/history')({
  component: forestOwnerLayout,
  staticData: {
    breadcrumb: 'Historikk',
  },
})

function forestOwnerLayout() {
  return (
    <div>
      <HistoryLayout />
    </div>
  )
}
